export const SightCategories = {
	lives: 'lives',
	neigh: 'neigh',
	around: 'around'
};
